import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window.preserveScroll ||= {};

    this.restoreScroll();
  }

  onScroll() {
    window.preserveScroll[this.element.id] = this.element.scrollLeft;
  }

  restoreScroll() {
    if (window.preserveScroll[this.element.id]) {
      this.element.scrollTo(window.preserveScroll[this.element.id], 0);
    }
  }
}
